import { Component, OnInit } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { APIService } from 'src/app/api.service';
@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

  isWeb: boolean = true;

  constructor(private router: Router, private Commservice : CommonService, private apiService : APIService) { }

  ngOnInit(): void {

    this.isWeb = this.apiService.apiCheckWeb();

    //alert("This feature is under development expected release in April 2021.");

  }

  reportArr: any = [{
  //   title: 'Material Requirement Planning (MRP)',
  //   titleColorCls: 'orangeText',
  //   itemHeaderColorCls: 'gradOrangeBkgd',
  //   reportItems: [
  //     {
  //       title: 'Production Planning',
  //       desc: 'Plan what products need to be manufactured for the next n days.',
  //       link: '',
  //       index: 1
  //     },
  //     {
  //       title: 'Purchase Planning',
  //       desc: 'Raw material purchase recommendation based on consumption and lead time',
  //       link: '',
  //       index: 2
  //     },
  //     {
  //       title: 'Material Availability Check',
  //       desc: 'Verification of availability of materials for production of selected products',
  //       link: '',
  //       index: 3
  //     }
  //   ]
  // },
  // {
  //   title: 'Analysis & Reforms',
  //   titleColorCls: 'greenText',
  //   itemHeaderColorCls: 'gradGreenBkgd',
  //   reportItems: [
  //     {
  //       title: 'Consumption Analysis',
  //       desc: 'Ideal vs Actual consumption of materials for past production jobs, to check over-use or misuse',
  //       link: '',
  //       index: 4
  //     },
  //     {
  //       title: 'Material Usage Trend',
  //       desc: 'Insight into material consumption trends - comparison by weekday, month, and year',
  //       link: '',
  //       index: 5
  //     },
  //     {
  //       title: 'Supplier Comparison',
  //       desc: 'Recommendations based on Cost & Quality for each item',
  //       link: '',
  //       index: 6
  //     }
  //   ]
  // },
  // {
    title: 'History & Logs',
    titleColorCls: 'darkBlueText',
    itemHeaderColorCls: 'gradDrkBlueBkgd',
    reportItems: [
      {
        title: 'Dispatch History',
        desc: 'Summary of dispatch transactions for a selected period',
        link: '',
        index: 7
      },
      {
        title: 'Issue History',
        desc: 'Summary of material issue transactions for a selected period',
        link: '',
        index: 8
      },
      {
        title: 'Production History',
        desc: 'Summary of production transactions for a selected period',
        link: '',
        index: 9
      },
      {
        title: 'Store Transfer History',
        desc: 'Summary of store transfer transactions for a selected period',
        link: '',
        index: 10
      },
      {
        title: 'Inward History',
        desc: 'Summary of material inward transactions for a selected period',
        link: '',
        index: 11
      },
      {
        title: 'Return History',
        desc: 'Summary of material return transactions for a selected period',
        link: '',
        index: 12
      },
      // {
      //   title: 'Reconciliation History',
      //   desc: 'Summary of material reconciliation transactions for a selected period',
      //   link: '',
      //   index: 13
      // },
      {
        title: 'Item Transactions Log',
        desc: 'Summary of material all item transactions for a selected period',
        link: '',
        index: 14
      },
       {
        title: 'Consolidated Stock Transactions',
        desc: 'Integrated report for transaction-wise totals, available summarized (in/out) or detailed',
        link: '',
        index: 15
      },
      {
        title: 'Purchase Report',
        desc: 'Summary of material all Purchase transactions for a selected period',
        link: '',
        index: 19
      },
      {
        title: 'Material Availability',
        desc: 'Verification of availability of materials for production of selected product',
        link: '',
        index: 20
      },
       {
        title: 'Non-Moving Stocks',
        desc: 'Summary of non-moving items which are used for few days ',
        link: '',
        index: 21
      },
      {
        title: 'Stock Shortfall',
        desc: 'Summary of items which are below the required stock levels',
        link: '',
        index: 22
      },
      {
        title: 'Batch Analysis',
        desc: 'Summary of items Batchwise',
        link: '',
        index: 23
      },
      {
        title: 'Trade Profitability',
        desc: 'Compare monthly purchase v/s sale of products',
        link: '',
        index: 24
      },
      {
        title: 'Material Requirement',
        desc: 'Verification of requirement of materials for production of multiple products',
        link: '',
        index: 25
      },
      {
        title: 'Job Work (Out) - Dispatch History',
        desc: 'Summary of job work dispatch transactions for a selected period',
        link: '',
        index: 26
      },
      {
        title: 'Job Work (Out) - Receipt History',
        desc: 'Summary of job work receive transactions for a selected period',
        link: '',
        index: 27
      }
      // {
      //   title: 'Scrap / Disposal History',
      //   desc: 'Summary of scrap / disposal transactions for a selected period',
      //   link: '',
      //   index: 15
      // },
      // {
      //   title: 'Item Transactions',
      //   desc: '',
      //   link: '',
      //   index: 16
      // }
    ]
  }
  ]

  InventoryReportsRedirect(index: number) {

    // if (index == 1) {
    //   this.router.navigate(['/productionplanning'])
    // }
    // if (index == 2) {
    //   this.router.navigate(['/purchaseplanning'])
    // }
    // if (index == 3) {
    //   this.router.navigate(['/materialavailabilitycheck'])
    // }

    // if (index == 4) {
    //   this.router.navigate(['/consumptionanalysis'])
    // }

    // if (index == 5) {
    //   this.router.navigate(['/materialusagetrend'])
    // }

    // if (index == 6) {
    //   this.router.navigate(['/suppliercomparison'])
    // }

    let target: string = "_blank";
    if(this.isWeb == false){
        target = "_self";
    }

    if (index == 7) {
      window.open('TransactionHistory?XnTypeID=4', target);
    }

    if (index == 8) {
      window.open('TransactionHistory?XnTypeID=5', target);
    }

    if (index == 9) {
      window.open('TransactionHistory?XnTypeID=7', target);
    }

    if (index == 10) {
      window.open('TransactionHistory?XnTypeID=9', target);
    }

    if (index == 11) {
      window.open('TransactionHistory?XnTypeID=1', target);
    }

    if (index == 12) {
      window.open('TransactionHistory?XnTypeID=2', target);
    }

    if (index == 13) {
      window.open('TransactionHistory?XnTypeID=8', target);
    }

    if (index == 14) {
      window.open('ItemTrasactionLog', target);
      // this.router.navigate(['/ItemTrasactionLog']);
    }
    if (index == 15) {
      window.open('ConsolidatedStockTransactions', target);
      // this.router.navigate(['/ConsolidatedStockTransactions']);
    }

    // if (index == 15) {
    //   window.open('TransactionHistory?XnTypeID=6',"_blank");
    // }

    if (index == 16) {
      window.open('', target);
      // this.router.navigate(['/'])
    }

    if (index == 17) {
      window.open('stock-breakdown', target);
      // this.router.navigate(['/stock-breakdown'])
    }

    if (index == 18) {
      window.open('purchasehistory', target);
      // this.router.navigate(['/purchasehistory'])
    }

    if (index == 19) {
      window.open('https://biziverse.com/main.html#/RptDailyPurchaseAnalysis', target);
    }
    if (index == 20) {
      window.open('RptInvMtlAvailability', target);
      // this.router.navigate(['/RptInvMtlAvailability'])
    }
    if (index == 21) {
      window.open('RptNonMovingItems', target);
    }
    if (index == 22) {
      window.open('RptStockShortfall', target);
      // this.router.navigate(['/RptStockShortfall']);
    }
    if (index == 23) {
      window.open('RptBatchAnalysis', target);
      // this.router.navigate(['/RptBatchAnalysis']);
    }
    if (index == 24) {
      window.open('https://biziverse.com/main.html#/RptTradeProfitability', target);
    }
    if (index == 25) {
      window.open('RptInvMultiMtlRequirement', target);
    }
    if (index == 26) {
      window.open('TransactionHistory?XnTypeID=12', target);
    }
    if (index == 27) {
      window.open('TransactionHistory?XnTypeID=13', target);
    }
  }

  backBtn() {
    this.router.navigate(['/Stock']);
  }
}


